var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#folder_ic_svg__clip0_982_5274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.917 20.792a2.083 2.083 0 01-2.084 2.083H4.167a2.083 2.083 0 01-2.084-2.083V6.208a2.083 2.083 0 012.084-2.083h5.208l2.083 3.125h9.375a2.084 2.084 0 012.084 2.083v11.459z",
    fill: "#1D7777",
    stroke: "#1D7777",
    strokeWidth: 2.083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "folder_ic_svg__clip0_982_5274"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 12.5 13)",
    d: "M0 0h25v25H0z"
  })))));
}
export default SvgFolderIc;